import CryptoJS from 'crypto-js';

export default function generateHash(plainText) {
  const hash = CryptoJS.SHA256(plainText).toString(CryptoJS.enc.Base64);
  return hash;
}
